import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, slideInLeft, slideInRight } from '../utils/animations';
// import { recipes } from '../services/api'; // Temporarily unused
import '../styles/About.css';

const About = () => {
  // Stats section temporarily disabled
  // const [stats, setStats] = useState([
  //   { number: '0', label: 'Receptek', emoji: '📖' },
  //   { number: '∞', label: 'Szeretet', emoji: '💕' }
  // ]);

  // useEffect(() => {
  //   fetchStats();
  // }, []);

  // const fetchStats = async () => {
  //   try {
  //     const response = await recipes.getAll({ approved: true });
  //     const allRecipes = response.data;

  //     // Receptek száma
  //     const recipeCount = allRecipes.length;

  //     setStats([
  //       { number: recipeCount.toString(), label: 'Receptek', emoji: '📖' },
  //       { number: '∞', label: 'Szeretet', emoji: '💕' }
  //     ]);
  //   } catch (error) {
  //     console.error('Error fetching stats:', error);
  //   }
  // };

  const values = [
    {
      title: 'Hagyományok őrzése és továbbfejlesztése',
      description: 'A hagyományos recepteket megőrizzük, de saját ízvilágunk szerint, saját kalandjaink tükrében alakítjuk és készítjük.'
    },
    {
      title: 'Főzés, ahogy jól esik',
      description: 'Nem mindig kellenek pontos mérések. Sokszor a szív és a lélek kell hogy vezérelje a kezünket, ahogyan anno nagymamáink is tették.'
    },
    {
      title: 'Közösség',
      description: 'Együtt osztozunk a receptekben, tapasztalatokban és a főzés örömében.'
    }
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <motion.div
          className="container"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <h1>Rólam</h1>
          <p className="subtitle">Az oldal története és küldetése</p>
        </motion.div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="container">
          <motion.div
            className="story-content"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.div variants={slideInLeft} className="story-text">
              <h2>Miért készült az Érzésre?</h2>
              <p>
                Az Érzésre oldal azért jött létre, hogy megőrizzük és megosszuk a házias konyha csodálatos hagyományait.
                A családi receptek nem gramm és milliliter szerint készültek, hanem szívvel, szeretettel és érzéssel.
              </p>
              <p>
                Amikor valaki még főzni tanul, kérdez, kapaszkodót keres, és a válasz annyi, hogy majd érzed. Csakhogy az érzés nem a semmiből jön.
                Tapasztalatból épül, abból, hogy egyszer kicsit több lett, máskor kicsit kevesebb, és a végeredmény máris más lett.
                A konyhában sokszor apró mennyiségek döntenek, és pont ezek azok, amiket ritkán ír le bárki.
              </p>
              <p>
                Az Érzésre ezt a láthatatlan részt szeretné láthatóvá tenni. Itt az érzésre nem homályos tanács, hanem kézzel fogható mennyiség.
                A recepteken ott van, mennyi az a csipet, az a löttyintés, az a marék, amit mások már rutinból csinálnak.
                Nem azért, hogy mindent centire kövess, hanem hogy tudd, honnan indulsz, és legyen miből kialakítani a saját ízlésedet.
                Így lesz a főzés egyszerre szabad és biztos, kreatív, de mégis kiszámítható.
              </p>
              <p>
                Ez az oldal egy közösségi tér, ahol mindenki megoszthatja saját receptjeit, családi titkait és főzési tapasztalatait.
                Hiszünk abban, hogy a főzés nem csak tudomány, hanem művészet is, hiszen a legjobb ételek érzésre készülnek.
              </p>
              <p>
                Csatlakozz hozzánk, és fedezzük fel együtt a házias konyha kincseit!
              </p>
            </motion.div>

            <motion.div variants={slideInRight} className="story-image">
              <img
                src="/about-hero.jpg"
                alt="Északi fény Finnországban - A főzési utazásom inspirációja"
                className="about-image"
              />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Stats Section - Temporarily hidden until site has more content */}
      {/* <section className="about-stats">
        <div className="container">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            Az Érzésre Számokban
          </motion.h2>
          <motion.div
            className="stats-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className="stat-card card"
                variants={fadeInUp}
              >
                <span className="stat-emoji">{stat.emoji}</span>
                <h3 className="stat-number">{stat.number}</h3>
                <p className="stat-label">{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section> */}

      {/* Values Section */}
      <section className="about-values">
        <div className="container">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            Miben hiszünk
          </motion.h2>
          <motion.div
            className="values-grid"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {values.map((value, index) => (
              <motion.div
                key={index}
                className="value-card card"
                variants={fadeInUp}
              >
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <motion.div
          className="container"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeInUp}
        >
          <h2>Kezdj el főzni érzésre!</h2>
          <p>Csatlakozz közösségünkhöz és oszd meg te is kedvenc receptjeidet</p>
          <div className="cta-buttons">
            <a href="/recipes" className="btn btn-primary">Receptek Böngészése</a>
            <a href="/register" className="btn btn-outline">Regisztráció</a>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default About;
